import {
  getDevicePlatform,
  getVersion,
  platform,
  subscribeToTopic, unsubscribeToTopic,
  requestPermission
} from "platformImpl";

import {
  getSeguro,
  getSeguroCache,
  postSeguro,
  putSeguro,
} from "../shared/helper/requests";

import { convertServicosToItemMenuList, removeServicoIndisponiveisDoMenu } from "./component/newdashboard/servicos";
import { isJson } from "shared/helper/utilitarioString";
import { showError } from "./../shared/helper/messages";
import configFirebase, { getConfig } from "../ext-libs/firebase";
import history from "../history";

const SituacaoVersaoEnum = {
  OK: 1,
  RECOMENDADO_ATUALIZAR: 2,
  EXIGIDO_ATUALIZAR: 3,
};

const verificarSituacaoVersao = (
  versaoAndroid,
  versaoIos,
  versaoMinimaRecomendadaAndroid,
  versaoMinimaExigidaAndroid,
  versaoMinimaRecomendadaIos,
  versaoMinimaExigidaIos
) => {
  try {
    const pattern = /(\d*)\.(\d*)\.(\d*)/;

    let minimaRecomendada, minimaExigida, versaoAtual;
    if (versaoAndroid !== null) {
      minimaRecomendada = pattern.exec(versaoMinimaRecomendadaAndroid);
      minimaExigida = pattern.exec(versaoMinimaExigidaAndroid);
      versaoAtual = pattern.exec(versaoAndroid);
    } else if (versaoIos !== null) {
      minimaRecomendada = pattern.exec(versaoMinimaRecomendadaIos);
      minimaExigida = pattern.exec(versaoMinimaExigidaIos);
      versaoAtual = pattern.exec(versaoIos);
    } else {
      return SituacaoVersaoEnum.OK;
    }

    if (minimaRecomendada && minimaExigida) {
      if (versaoAtual) {
        const [versaoParte1, versaoParte2, versaoParte3] = versaoAtual
          .slice(1)
          .map(Number);
        const [recomendadaParte1, recomendadaParte2, recomendadaParte3] =
          minimaRecomendada.slice(1).map(Number);
        const [exigidaParte1, exigidaParte2, exigidaParte3] = minimaExigida
          .slice(1)
          .map(Number);

        if (
          versaoParte1 < exigidaParte1 ||
          (versaoParte1 === exigidaParte1 && versaoParte2 < exigidaParte2) ||
          (versaoParte1 === exigidaParte1 &&
            versaoParte2 === exigidaParte2 &&
            versaoParte3 < exigidaParte3)
        ) {
          return SituacaoVersaoEnum.EXIGIDO_ATUALIZAR;
        } else if (
          versaoParte1 < recomendadaParte1 ||
          (versaoParte1 === recomendadaParte1 &&
            versaoParte2 < recomendadaParte2) ||
          (versaoParte1 === recomendadaParte1 &&
            versaoParte2 === recomendadaParte2 &&
            versaoParte3 < recomendadaParte3)
        ) {
          return SituacaoVersaoEnum.RECOMENDADO_ATUALIZAR;
        }

        return SituacaoVersaoEnum.OK;
      } else {
        console.error(
          `Versão inválida: versaoAtual=${versaoAtual}; versaoAndroid=${versaoAndroid}; versaoIos=${versaoIos}.`
        );
        return "Erro interno do servidor";
      }
    } else {
      console.error(
        `Parâmetros de versão inválidos: versaoMinimaRecomendadaAndroid=${versaoMinimaRecomendadaAndroid}; versaoMinimaExigidaAndroid=${versaoMinimaExigidaAndroid}; versaoMinimaRecomendadaIos=${versaoMinimaRecomendadaIos}; versaoMinimaExigidaIos=${versaoMinimaExigidaIos}.`
      );
      return "Falha ao verificar versão de app";
    }
  } catch (e) {
    console.error(e, "Falha ao verificar versão de app");
    return "Falha ao verificar versão de app";
  }
};

export const requestLaunchSagService = (service, origemClick = "") => ({
  type: "APP_REQUEST_LAUNCH_SAG_SERVICE",
  payload: {
    sagService: service,
    origemClick: origemClick
  },
});

export const dismissLaunchSagService = () => ({
  type: "APP_LAUNCH_SAG_SERVICE_DISMISSED",
});

export const requestLaunchExternalLink = (url) => ({
  type: "APP_REQUEST_LAUNCH_EXTERNAL_LINK",
  payload: url + "?TEMP="+new Date().getTime(),
});

export const dismissLaunchExternalLink = () => ({
  type: "APP_LAUNCH_EXTERNAL_DISMISSED",
});

export const atualizarBusca = (event) => ({
  type: "APP_BUSCA_ALTERADA",
  payload: typeof event === "string" ? event : event.target.value,
});

export const limparBusca = () => ({
  type: "APP_BUSCA_ALTERADA",
  payload: "",
});

export const itensMenuRecebido = (data) => ({
  type: "APP_ITENS_MENU_RECEBIDOS",
  payload: data,
});

const resultSagServices = (dados) => ({
  type: "APP_CATALOGO_SAG_RECEBIDO",
  payload: dados,
});

const errorSagServices = () => ({
  type: "APP_ERRO_SOLICITACAO_SAG",
});

const resultGestaoHome = (dados) => dispatch => {
  const regra = platform.isCordova ? "isDisponivelMobile" : "isDisponivelWeb";
  const servicosDisponiveis = removeServicoIndisponiveisDoMenu(dados, regra);
  const servicosRecomendados = convertServicosToItemMenuList(servicosDisponiveis);

  return dispatch({
    type: "APP_ITENS_SERVICOS_RECOMENDADOS_RECEBICOS",
    payload: servicosRecomendados
  })
}

const resultGestaoParametros = (dados) => dispatch => {
  const parametros = dados?.data ?? null;
  return dispatch({
    type: "APP_PARAMETROS_RECEBICOS",
    payload: parametros,
  })
}

const errorGestaoServices = () => ({
  type: "APP_ERRO_SOLICITACAO_GESTAO",
});

export function requestSagService() {
  return (dispatch) => {
    dispatch({ type: "APP_SOLICITADO_CATALOGO_SAG" });
    let plataforma = platform.isCordova
      ? "?plataforma=MOBILE"
      : "?plataforma=WEB";

    return getSeguroCache(
      dispatch,
      `SagService/cidadao/servicos${plataforma}`,
      (dados) => {
        localStorage.setItem('listaServicosSag', JSON.stringify(dados.servicosSag));
        return resultSagServices(dados.servicosSag);
      },
      errorSagServices
    );
  };
}

export function requestGestaoHome(idPerfil) {
  return (dispatch) => {
    dispatch({ type: "APP_SOLICITADO_CATALOGO_GESTAO" });
    dispatch({type: "APP_REQUEST_SERVICOS_RECOMENDADOS"});
    return getSeguroCache(
      dispatch,
      `gestaoservices/home/perfil/${idPerfil}`,
      (dados) => resultGestaoHome(dados),
      errorGestaoHome
    )
  }
}

const errorGestaoHome = () => ({
  type: "APP_ITENS_SERVICOS_RECOMENDADOS_ERRO",
  payload: null
});

export function requestGestaoParametros() {
  return (dispatch) => {
    dispatch({ type: "APP_SOLICITADO_CATALOGO_GESTAO" });
    return getSeguroCache(
      dispatch,
      `gestaoservices/parametros/todos`,
      (dados) => resultGestaoParametros(dados),
      errorGestaoServices,
    )
  }
}

const resultBannerGestaoServices = (dados, salvarCache) => {
      return {
    type: "APP_ITENS_BANNERS_RECEBIDOS",
    payload: dados,
  };
};

export const iniciarRequisicaoBanners = () => {
  return {
    type: "APP_REQUEST_BANNERS",
  };
};

const errorBannerGestaoServices = () => ({
  type: "APP_ERRO_SOLICITACAO_GESTAO_BANNER",
});

export function requestBannerGestaoService() {
  return (dispatch) => {

    dispatch(iniciarRequisicaoBanners());

    return getSeguroCache(
      dispatch,
      `gestaoservices/banners`,
      (dados) => resultBannerGestaoServices(dados, true),
      errorBannerGestaoServices
    );
  };
}

export const requestServicosSemSenha = () => {
  return (dispatch) => {
    dispatch(iniciarRequisicaoServicosSemSenha());
    return getSeguroCache(
      dispatch,
      `gestaoservices/home-perfil/sem-senha`,
      (dados) => resultServicosSemSenha(dados),
      errorServicosSemSenha
    );
  };
}

const iniciarRequisicaoServicosSemSenha = () => ({
  type: "APP_REQUEST_SERVICOS_SEM_SENHA",
});


const resultServicosSemSenha = (dados) => {
      return {
    type: "APP_ITENS_SERVICOS_SEM_SENHA_RECEBIDOS",
    payload: dados,
  };
};

const errorServicosSemSenha = () => ({
  type: "APP_ERRO_SOLICITACAO_SERVICOS_SEM_SENHA",
  payload: null
});

export const onDialogRegisterDevice = (open) => {
  return { type: "APP_DIALOG_DEVICE_REGISTER", payload: open };
};

const getInfoDeviceServiceSucesso = (dados) => (dispatch) => {
  if (dados.autorizacao && dados.situacao != "DISPOSITIVO_ANTERIOR_AUTORIZADO") {
    requestPermission();
  }
  dispatch({
    type: "APP_DEVICE_GET_INFO",
    payload: dados,
  });
};

const getInfoDeviceServiceFalha = (error) => (dispatch) => {
  console.debug("Erro ao tentar consultar informações do aparelho.");
};

export const getInfoDeviceService = (token) => (dispatch) => {
  return getSeguro(
    dispatch,
    `notificacoesRegistro/dispositivos/consultarSituacao/${token}`,
    getInfoDeviceServiceSucesso,
    getInfoDeviceServiceFalha
  );
};

const registroDeviceSucesso = (dados) => (dispatch) => {
  if (dados.autorizarNotificacao) {
    requestPermission();
  }
  dispatch({
    type: "APP_DEVICE_REGISTERED",
    payload: { autorizacao: dados.autorizarNotificacao },
  });
  history.replace("/");
};

const registroDeviceFalha = (error) => (dispatch) => {
  dispatch({ type: "APP_DEVICE_REGISTERED_ERROR" });
  history.replace("/");
};

export const registrarDeviceService =
  (token, permissao, plataforma) => (dispatch) => {
    const dados = {
      token: token,
      plataforma: plataforma,
      autorizarNotificacao: permissao,
    };
    if (permissao) {
      subscribeToTopic();
    } else {
      unsubscribeToTopic();
    }
    postSeguro(
      dispatch,
      `notificacoesRegistro/dispositivos`,
      dados,
      registroDeviceSucesso,
      registroDeviceFalha
    );
  };

const ativarDesativarNotificacaoSucesso = (dados) => (dispatch) => {
  if (dados.autorizarNotificacao) {
    requestPermission();
  }
  dispatch({
    type: "APP_NOTIFICATION_REGISTERED",
    payload: { autorizacao: dados.autorizarNotificacao },
  });
};

const ativarDesativarNotificacaoFalha = (error, autorizarNotificacao) => (dispatch) => {
  dispatch({
    type: "APP_NOTIFICATION_REGISTERED",
    payload: { autorizacao: autorizarNotificacao },
  });
  showError("Erro ao tentar ativar/desativar notificações no aparelho.");
};

export const ativarDesativarNotificacaoService =
  (token, permissao, plataforma) => (dispatch) => {
    dispatch({
      type: "APP_NOTIFICATION_REGISTERED",
      payload: { autorizacao: permissao },
    });
    const dados = {
      token: token,
      plataforma: plataforma,
      autorizarNotificacao: permissao,
    };
    if (permissao) {
      subscribeToTopic();
    } else {
      unsubscribeToTopic();
    }
    putSeguro(
      dispatch,
      `notificacoesRegistro/dispositivos/autorizarNotificacao`,
      dados,
      ativarDesativarNotificacaoSucesso,
      (error) => (dispatch) => { dispatch(ativarDesativarNotificacaoFalha(error, !permissao)); }
    );
  };

export function servicoSelecionado(servico) {
  return { type: "APP_SERVICO_SELECIONADO", payload: servico };
}

export function gravaBreadcrumb(grava = true) {
  return { type: "APP_GRAVA_BREADCRUMB", payload: grava };
}

export const verificarParametrosFirebase = () => {
  return (dispatch) => {
    configFirebase().then(async () => {
      // Verifica necessidade de atualizar versão do app
      if (platform.isCordova) {
        const versaoMinimaRecomendadaAndroid = getConfig(
          "versaoMinimaRecomendadaAndroid"
        );
        const versaoMinimaExigidaAndroid = getConfig(
          "versaoMinimaExigidaAndroid"
        );
        const versaoMinimaRecomendadaIos = getConfig(
          "versaoMinimaRecomendadaIos"
        );
        const versaoMinimaExigidaIos = getConfig("versaoMinimaExigidaIos");

        if (getDevicePlatform() === "Android") {
          const version = await getVersion();
          const situacaoVersao = verificarSituacaoVersao(
            version,
            null,
            versaoMinimaRecomendadaAndroid,
            versaoMinimaExigidaAndroid,
            versaoMinimaRecomendadaIos,
            versaoMinimaExigidaIos
          );
          dispatch({
            type: "ATUALIZACAO_APP",
            payload: situacaoVersao,
          });
        } else if (getDevicePlatform() === "iOS") {
          const version = await getVersion();
          const situacaoVersao = verificarSituacaoVersao(
            null,
            version,
            versaoMinimaRecomendadaAndroid,
            versaoMinimaExigidaAndroid,
            versaoMinimaRecomendadaIos,
            versaoMinimaExigidaIos
          );
          dispatch({
            type: "ATUALIZACAO_APP",
            payload: situacaoVersao,
          });
        }
      }
    });
  };
};

const getMenuPrincipalFromGestaoSuccess = (data) => dispatch => {
  if (data && data.length > 0 && isJson(data)) {
    const regra = platform.isCordova ? "isDisponivelMobile" : "isDisponivelWeb";
    const servicosDisponiveis = removeServicoIndisponiveisDoMenu(data, regra);
    const menuItems = convertServicosToItemMenuList(servicosDisponiveis);
    return dispatch({
      type: "APP_ITENS_MENU_RECEBIDOS",
      payload: menuItems,
    })
    }
  return dispatch({
    type: "APP_GESTAO_INDISPONIVEL",
    payload: true,
  })
}

export const getMenuPrincipalFromGestao = () => (dispatch) => {
  getSeguroCache(
    dispatch,
    `gestaoservices/menu/view/menu-principal`,
    getMenuPrincipalFromGestaoSuccess,
    (error) => {
      return getMenuPrincipalFromGestaoSuccess(null)
    }
  );
}

export const setSolicitandoMenu = (value) => (dispatch) => {
  return dispatch({
    type: 'APP_SET_SOLICITANDO_MENU',
    payload: value
  })
}

export const setTituloPagina = (value) => (dispatch) => {
  if (value) {
    return dispatch({
      type: 'APP_ATUALIZAR_TITULO_PAGINA',
      payload: value
    })
  }  
}

export const setMsgAcessoProcurador = (value) => (dispatch) => {
  return dispatch({
    type: 'APP_ATUALIZAR_MSG_ACESSO_PROCURADOR',
    payload: value
  })
}

export const setSearchText = (value) => (dispatch) => {
  return dispatch({
    type: 'APP_SEARCH_TEXT',
    payload: value
  })
}

export const setFilter = (value) => (dispatch) => {
  return dispatch({
    type: 'APP_SEARCH_FILTER',
    payload: value
  })
}


export const setTodosServicos = (value) => (dispatch) => {
  return dispatch({
    type: 'APP_SEARCH_TODOS',
    payload: value
  })
}

export const addToDicionarioPaths = (pathname, title) => (dispatch) => {
  return dispatch({
    type: 'APP_ADD_TO_DICIONARIO_PATH',
    payload: {
      pathname: pathname,
      title: title
    }
  })
}

export const buscarFoto = () => dispatch => {
  return getSeguro(dispatch, 'carteiraServices/download',
    receberFotoSucesso,
    receberFotoErro);
}

export const receberFotoSucesso = dados => ({
  type: 'CARTEIRA_BUSCA_FOTO_SUCESSO',
  payload: dados
});

export const receberFotoErro = error => {
  console.error(error);
  return ({ type: 'CARTEIRA_BUSCA_FOTO_ERROR' });
}

export const setIsMenuActive = (value) => ({
  type: 'SET_IS_MENU_ACTIVE',
  payload: value
})

export const setMensagemErro = (value) => ({
  type: 'APP_MENSAGEM_ERRO',
  payload: value
})

export const setBreadcrumb = (value) => ({
  type: 'APP_BREADCRUMB',
  payload: value
});

export const resetBreadcrumb = () => ({
  type: 'APP_RESET_BREADCRUMB'
})